import { Component } from 'react'
import { prependHttp } from 'utils'
import * as h from 'h'

import StandardContent from 'components/Popout/StandardContent'
import { projectTypeBrands } from 'config'

import styles from './styles.scss'

export default class CompanyView extends Component {
  render () {
    const { element } = this.props
    const { name, image, type, subtype, descShort, externalLink } = element

    const brand = projectTypeBrands[type && type.slug]
    const vanillaImage = true

    const postContent = externalLink
              ? h.div(null,
                  h.a({href: prependHttp(externalLink), target: '_blank', ...h.ca(styles.externalLink)}, 'Visit Company Website'))
              : null

    return h.div(null,
      h.h(StandardContent, {
        title: name,
        labels: [
          type && { brand, content: type.name },
          subtype && { brand: 'primary', content: subtype.name }
        ],
        content: descShort,
        image: image.details,
        vanillaImage,
        postContent
      }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/CompanyView/index.js